import { render, staticRenderFns } from "./SubTitle7.vue?vue&type=template&id=199e08d6&scoped=true&"
import script from "./SubTitle7.vue?vue&type=script&lang=js&"
export * from "./SubTitle7.vue?vue&type=script&lang=js&"
import style0 from "./SubTitle7.vue?vue&type=style&index=0&id=199e08d6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199e08d6",
  null
  
)

export default component.exports